import React from 'react'
import { CircularProgress } from '@material-ui/core'

const montserratStyle = { fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }

interface ReviewKpiCardProps {
  title: string
  value: React.ReactNode
  subtitle?: string
  isLoading?: boolean
  className?: string
}

export const ReviewKpiCard: React.FC<ReviewKpiCardProps> = ({
  title,
  value,
  subtitle,
  isLoading = false,
  className = '',
}) => (
  <div
    className={`bg-white rounded-2xl p-6 flex flex-col overflow-hidden ${className}`}
    style={montserratStyle}
  >
    <span className="text-base font-bold mb-1">{title}</span>
    {isLoading ? (
      <CircularProgress size={24} />
    ) : (
      <>
        <span className="text-2xl md:text-3xl font-extrabold mb-2 leading-tight whitespace-nowrap">
          {value}
        </span>
        {subtitle && <span className="text-gray-600 text-sm">{subtitle}</span>}
      </>
    )}
  </div>
)

ReviewKpiCard.defaultProps = {
  subtitle: undefined,
  isLoading: false,
  className: '',
}
